import React from 'react';
import { useTranslation } from 'react-i18next';

const pageStyle: React.CSSProperties = {
  maxWidth: '900px',
  margin: '0 auto',
  lineHeight: 1.7,
  color: '#1f2937',
};

const headingStyle: React.CSSProperties = {
  fontSize: '30px',
  marginBottom: '12px',
};

const sectionTitleStyle: React.CSSProperties = {
  fontSize: '20px',
  marginTop: '24px',
  marginBottom: '8px',
};

export const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t('siteInfo.about.title')}</h1>
      <p>{t('siteInfo.about.intro')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.about.sectionToolsTitle')}</h2>
      <p>{t('siteInfo.about.sectionToolsContent')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.about.sectionAudienceTitle')}</h2>
      <p>{t('siteInfo.about.sectionAudienceContent')}</p>
    </div>
  );
};

export const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t('siteInfo.contact.title')}</h1>
      <p>{t('siteInfo.contact.intro')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.contact.feedbackTitle')}</h2>
      <p>{t('siteInfo.contact.feedbackContent')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.contact.cooperationTitle')}</h2>
      <p>{t('siteInfo.contact.cooperationContent')}</p>
      <p>{t('siteInfo.contact.email')}</p>
    </div>
  );
};

export const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={pageStyle}>
      <h1 style={headingStyle}>{t('siteInfo.privacy.title')}</h1>
      <p>{t('siteInfo.privacy.intro')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.privacy.dataTitle')}</h2>
      <p>{t('siteInfo.privacy.dataContent')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.privacy.adsTitle')}</h2>
      <p>{t('siteInfo.privacy.adsContent')}</p>
      <h2 style={sectionTitleStyle}>{t('siteInfo.privacy.policyTitle')}</h2>
      <p>{t('siteInfo.privacy.policyContent')}</p>
    </div>
  );
};
